import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const guides = [
  {
    to: '/article/usfans-spreadsheet-guide',
    icon: 'ri-book-open-line',
    titleKey: 'home.guide.article.title',
    descKey: 'home.guide.article.desc',
    image:
      'https://readdy.ai/api/search-image?query=An%20open%20book%20and%20a%20digital%20tablet%20showing%20a%20spreadsheet%20on%20a%20warm%20wooden%20desk%2C%20soft%20natural%20light%2C%20calm%20reading%20and%20research%20scene%2C%20minimal%20editorial%20flat%20lay%2C%20fresh%20clean%20mood%2C%20no%20readable%20text&width=800&height=600&seq=guide-beginner-01&orientation=landscape',
  },
  {
    to: '/topics/review',
    icon: 'ri-star-line',
    titleKey: 'home.guide.review.title',
    descKey: 'home.guide.review.desc',
    image:
      'https://readdy.ai/api/search-image?query=Five%20golden%20star%20rating%20symbols%20above%20a%20pair%20of%20hands%20holding%20a%20notebook%2C%20warm%20soft%20light%2C%20evaluation%20and%20review%20concept%2C%20minimal%20editorial%20photography%2C%20clean%20fresh%20mood%2C%20no%20text&width=800&height=600&seq=guide-review-01&orientation=landscape',
  },
  {
    to: '/topics/shipping-cost',
    icon: 'ri-truck-line',
    titleKey: 'home.guide.shipping.title',
    descKey: 'home.guide.shipping.desc',
    image:
      'https://readdy.ai/api/search-image?query=A%20cardboard%20parcel%20box%20with%20a%20shipping%20label%20sticker%20and%20a%20small%20truck%20toy%20on%20a%20clean%20light%20surface%2C%20soft%20warm%20light%2C%20logistics%20and%20delivery%20concept%2C%20minimal%20editorial%20photography%2C%20no%20readable%20text&width=800&height=600&seq=guide-shipping-01&orientation=landscape',
  },
  {
    to: '/topics/safety',
    icon: 'ri-shield-star-line',
    titleKey: 'home.guide.safety.title',
    descKey: 'home.guide.safety.desc',
    image:
      'https://readdy.ai/api/search-image?query=A%20shield%20with%20a%20checkmark%20and%20a%20padlock%20on%20a%20soft%20pastel%20background%2C%20soft%20even%20lighting%2C%20online%20safety%20and%20trust%20concept%2C%20minimal%20editorial%20photography%2C%20fresh%20calm%20mood%2C%20no%20text&width=800&height=600&seq=guide-safety-01&orientation=landscape',
  },
];

export default function Guides() {
  const { t } = useTranslation();

  return (
    <section className="mx-auto max-w-7xl px-4 py-14 md:px-6 md:py-20 lg:px-8">
      <div className="flex flex-col items-center text-center">
        <h2 className="font-heading text-2xl font-bold text-foreground-950 md:text-4xl">{t('home.guidesTitle')}</h2>
        <p className="mt-3 max-w-2xl text-sm text-foreground-600 md:text-base">{t('home.guidesSub')}</p>
      </div>

      <div className="mt-10 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
        {guides.map((g) => (
          <Link
            key={g.to}
            to={g.to}
            className="group overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-colors hover:border-primary-300"
          >
            <div className="relative h-40 w-full overflow-hidden">
              <img
                src={g.image}
                alt={t(g.titleKey)}
                className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
              />
            </div>
            <div className="p-5">
              <span className="flex h-10 w-10 items-center justify-center rounded-lg bg-secondary-50 text-secondary-600">
                <i className={`${g.icon} text-xl`}></i>
              </span>
              <h3 className="mt-3 text-base font-semibold text-foreground-950">{t(g.titleKey)}</h3>
              <p className="mt-2 text-sm leading-relaxed text-foreground-600">{t(g.descKey)}</p>
              <span className="mt-4 inline-flex items-center gap-1 text-sm font-medium text-primary-600">
                {t('common.readMore')}
                <span className="flex h-4 w-4 items-center justify-center transition-transform group-hover:translate-x-0.5">
                  <i className="ri-arrow-right-line text-base"></i>
                </span>
              </span>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}